<template>
    <div>
        <b-modal v-model="show"
                 @hidden="onHidden"
                 ref="modal"
                 size="sm"
                 hide-footer
                 fadeOutDown
                 okVariant="success"
                 centered
                 v-bind:title="'Beállítások'">
            <b-form-group>
                <div class="col-md-12">
                    <div class="form-group">
                        <range-slider class="slider float-right"
                                      min="0.70"
                                      max="1"
                                      step="0.01"
                                      v-model="tableSize">
                        </range-slider>
                        <p> Méret: {{ Math.round(tableSize * 100) + "%"}}</p>
                    </div>

                </div>
            </b-form-group>
            <b-btn class="mt-3"
                   variant="success"
                   block
                   @click="onHidden">Rendben</b-btn>
        </b-modal>
    </div>
</template>
<script>
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";

export default {
  props: ["size"],
  components: {
    RangeSlider
  },
  watch: {
    tableSize: function(size) {
      this.$emit("updated", size);
    }
  },

  data() {
    return {
      show: true,
      tableSize: this.size
    };
  },
  methods: {
    onHidden(evt) {
      this.$emit("close");
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/TableSettings.vue